<template>
  <div class="row" :style="{margin, paddingTop: pt}" :class="{mobileOneRow}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Row',
  props: {
    margin: String,
    pt: String,
    mobileOneRow: Boolean
  }
}
</script>

<style scoped lang="scss">
.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

@media screen and (max-width: 1170px) {
  .mobileOneRow {
    overflow: auto;
    flex-wrap: nowrap;
  }
}
</style>
